import { ReactNode } from 'react';
import dynamic from 'next/dynamic';
import { Box, Flex, Text } from '@chakra-ui/react';
import Image from './Image';
import { MhyImage, MhyChakraProps } from '../types';
import Heading from './Heading';

const YoutubeVideoEmbed = dynamic(() => import('./YoutubeVideoEmbed'));

interface HeroSplitProps extends Omit<MhyChakraProps, 'variant'> {
  title: string;
  leadText: string;
  image?: MhyImage;
  video?: string | null;
  children?: ReactNode;
}

const HeroSplit = ({
  title,
  leadText,
  image,
  children,
  video,
  ...rest
}: HeroSplitProps) => (
  <Box {...rest}>
    <Flex
      alignItems="stretch"
      flexDirection={[
        'column-reverse',
        'column-reverse',
        'column-reverse',
        'row',
      ]}
      gridColumnGap="2"
      justifyContent="space-between"
    >
      <Flex
        flexDirection="column"
        justifyContent="center"
        alignItems="flex-start"
        flex={['0 0 100%', '0 0 100%', '0 0 100%', '0 0 50%']}
        py={8}
      >
        <Heading as="h1" variant="h1" mb={7}>
          {title}
        </Heading>
        {leadText && (
          <Text
            textStyle="xl"
            sx={{ ':not(:last-child)': { mb: 7 } }}
            maxWidth="44ch"
            pr="2"
          >
            {leadText}
          </Text>
        )}
        {children}
      </Flex>
      <Box flex={['0 0 100%', '0 0 100%', '0 0 100%', '0 0 50%']}>
        {
          // eslint-disable-next-line no-nested-ternary
          video ? (
            <YoutubeVideoEmbed title={title} videoSrc={video} heroMode />
          ) : image?.src ? (
            <Image
              width="900"
              height="600"
              src={image.src}
              alt={image.alt || title}
            />
          ) : null
        }
      </Box>
    </Flex>
  </Box>
);

export default HeroSplit;
